export const VMSCacheKey = {
    CONSENT_LETTER: 'CACHE_CONSENT_LETTER',

    // VISIT_REQUEST_SITE_ID: 'VISIT_REQUEST_SITE_ID',
    // VISIT_REQUEST_SITE_NAME: 'VISIT_REQUEST_SITE_NAME'
};